import type { InjectionKey } from 'vue';
import type { Drawer } from './drawer';

export const drawerKey = Symbol('drawer') as InjectionKey<Drawer>;
